import React from 'react'
import classNames from 'classnames'
import { createPortal } from 'react-dom'

const Header = ({ children }) => (
  <div className="filter-popup__header">
    {children}
  </div>
)

const Body = ({ children }) => (
  <div className="filter-popup__body">
    {children}
  </div>
)

const Footer = ({ children }) => (
  <div className="filter-popup__footer">{children}</div>
)

const FilterPopup = (props) => {
  const { children, className, popupRef } = props
  const portal = document.getElementById('modal-portal');

  const popupElement = (
    <div
      className={classNames('filter-popup', {
        [className]: className
      })}
      ref={popupRef}
    >
      {children}
    </div>
  )

  if (window.innerWidth < 768) {
    return createPortal(popupElement, portal)
  }

  return popupElement;
}

export default Object.assign(FilterPopup, {
  Header,
  Body,
  Footer
})
